import { MediumLargeHeadingStyled } from "src/components/custom/texts/texts.styled";
import { Card, Form, Input, Modal, Select, Table, Skeleton } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import { Button, Flex, Icon } from "@nubeteck/components";
import { ITransferencia } from "src/Interfaces/transfer";
import { useGetTransfersStatusQuery } from "src/services/reviewsServices";
import { ArrayUtils, FormatterUtils } from "@nubeteck/utils";
import { formatDate } from "src/utils/date-util";
import { getSettingsPage } from "src/Api/content";
import { useLocale } from "src/i18n/localeContext";
import { StrapiError } from "../../StrapiError";

function Transfers({
  isLoading,
  getData,
  data,
  getFile,
  isLoadingFile,
  changeState,
  pageNumber,
  setPageNumber,
  rowsCount,
  setRowsCount,
}: any) {
  const [studentName, setStudentName] = React.useState("");
  const [studentId, setStudentId] = React.useState("");
  const [estadoId, setEstadoId] = React.useState(0);
  const [modal, contextHolder] = Modal.useModal();

  const { locale } = useLocale();
  const [settingsPage, setSettingsPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState(false);
  const detail = settingsPage?.transfer_review_detail;

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);

    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setSettingsPage(null);
        setIsLoadingContent(false);
        setHasError(locale === "en");
      }
    }, 3000);

    getSettingsPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setSettingsPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setSettingsPage(null);
          setIsLoadingContent(false);
          setHasError(locale === "en");
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  const { data: status } = useGetTransfersStatusQuery();

  const filterStatusOptions = ArrayUtils.selectLabelValue(
    status?.data ?? [],
    "estadoNombre",
    "estadoId",
  );

  const confirm = (record: ITransferencia) => {
    modal.confirm({
      title:
        record.estadoId === 7
          ? detail?.confirm_accept_title || "¿Desea aceptar este aval de transferencia?"
          : detail?.confirm_deny_title || "¿Desea denegar este aval de transferencia?",
      icon: <Icon name="" color="#FFC53D" />,
      content: `${detail?.confirm_content_template || "La transferencia notificada será procesada según su decisión."} (${record.nombreCompleto} - ${formatDate(record.fecha)})`,
      okText: record.estadoId === 7 ? (detail?.accept_button || "Aceptar transferencia") : (detail?.deny_button || "Denegar transferencia"),
      onOk: () => {
        changeState({
          estadoId: record.estadoId,
          pagoFormaPagoId: record.pagoFormaPagoId,
          fileId: record.fileId,
        });
      },
      cancelText: detail?.cancel_button || "Cancelar",
      style: { top: 200 },
    });
  };

  // const { data: status } = useGetTransfersStatusQuery();

  useEffect(() => {
    getData({
      rowsCount,
      page: pageNumber,
      nombre: studentName,
      estadoId: estadoId,
      id: studentId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentName, rowsCount, pageNumber, estadoId, studentId]);

  // const filterStatusOptions = ArrayUtils.selectLabelValue(status?.data ?? [], "estado", "estadoId");

  const columns = React.useMemo<ColumnsType<ITransferencia>>(
    () => [
      {
        title: settingsPage?.transfer_review_table?.[0]?.label || "Fecha",
        dataIndex: "fecha",
        render: (value) => formatDate(value),
      },
      {
        title: settingsPage?.transfer_review_table?.[1]?.label || "ID",
        dataIndex: "id",
      },
      {
        title: settingsPage?.transfer_review_table?.[2]?.label || "Estudiante",
        dataIndex: "nombreCompleto",
      },
      {
        title: settingsPage?.transfer_review_table?.[3]?.label || "Entidad financiera",
        dataIndex: "entidadFinancieraNombre",
      },
      {
        title: settingsPage?.transfer_review_table?.[4]?.label || "Número de transacción",
        dataIndex: "numero",
      },
      {
        title: settingsPage?.transfer_review_table?.[5]?.label || "Monto",
        dataIndex: "monto",
        render: (value) => FormatterUtils.number(value.toFixed(2)),
      },
      {
        title: settingsPage?.transfer_review_table?.[6]?.label || "Moneda",
        dataIndex: "monedaNombre",
      },
      {
        title: settingsPage?.transfer_review_table?.[7]?.label || "Estado",
        dataIndex: "estadoNombre",
      },
      {
        title: settingsPage?.transfer_review_table?.[8]?.label || "Archivo",
        dataIndex: "fileId",
        render: (value) => (
          <Button
            type="link"
            icon={<Icon name="" />}
            onClick={() => getFile(detail?.download_filename || "Aval transferencia", value)}
          ></Button>
        ),
      },
      {
        title: "",
        dataIndex: "pagoFormaPagoId",
        render: (pagoFormaPagoId, record) => {
          const reg = data?.data?.result?.find((tr: any) => tr.pagoFormaPagoId === pagoFormaPagoId);
          return (
            <Flex>
              {reg.estadoId !== 7 && reg.estadoId !== 10 ? (
                <Button type="text" onClick={() => confirm({ ...record, estadoId: 7 })}>
                  {detail?.accept_action_label || "Aceptar"}
                </Button>
              ) : null}
              {reg.estadoId !== 10 && reg.estadoId !== 7 ? (
                <Button type="text" onClick={() => confirm({ ...record, estadoId: 10 })}>
                  {detail?.deny_action_label || "Denegar"}
                </Button>
              ) : null}
            </Flex>
          );
        },
      },
    ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [changeState, getFile],
  );
  if (hasError && locale === "en") {
    return (
      <StrapiError
        onRetry={() => {
          setHasError(false);
          setIsLoadingContent(true);
        }}
        onUseDefault={() => {
          setHasError(false);
          setIsLoadingContent(false);
          setSettingsPage(null);
        }}
      />
    );
  }

  if (isLoadingContent) {
    return (
      <Flex style={{ width: "100%", flexDirection: "column", gap: 16 }}>
        <Skeleton.Input active size="large" style={{ width: 300 }} />
        <Skeleton active paragraph={{ rows: 6 }} />
      </Flex>
    );
  }

  return (
    <>
      <MediumLargeHeadingStyled>{detail?.title || "Transferencias notificadas"}</MediumLargeHeadingStyled>
      <Flex style={{ gap: "15px", alignItems: "center" }}>
        <Form.Item label={detail?.search_by_id_label || "Búsqueda por ID"}>
          <Input
            type="text"
            onChange={(e) => setStudentId(e.target.value)}
            placeholder={detail?.search_by_id_label || "Búsqueda por ID"}
          />
        </Form.Item>
        <Form.Item label={detail?.search_by_name_label || "Búsqueda por nombre de estudiante"}>
          <Input
            type="text"
            onChange={(e) => setStudentName(e.target.value)}
            placeholder={detail?.search_by_name_label || "Búsqueda por nombre de estudiante"}
          />
        </Form.Item>
        <Form.Item label={detail?.filter_status_label || "Filtro por estado"}>
          <Select
            options={filterStatusOptions}
            placeholder={detail?.select_status_placeholder || "Seleccione un estado"}
            allowClear
            onChange={(e) => {
              setEstadoId(e);
            }}
          />
        </Form.Item>
      </Flex>
      <Card bodyStyle={{ padding: 0, width: "100%" }}>
        <Table<ITransferencia>
          loading={isLoading || isLoadingFile}
          columns={columns}
          dataSource={data?.data?.result}
          rowKey={(v) => v.pagoId}
          pagination={{
            onChange(page, pageSize) {
              setPageNumber(page);
              setRowsCount(pageSize);
            },
            pageSize: rowsCount,
            current: pageNumber,
            total: data?.data?.pageCount * rowsCount,
            showSizeChanger: true,
            style: { marginRight: "30px" },
          }}
          scroll={{ x: 800 }}
        />
      </Card>
      {contextHolder}
    </>
  );
}

export default Transfers;
